













import { Component, Vue } from "vue-property-decorator";

@Component
export default class VerifyReset extends Vue {  
  mounted(){
    let emailStorage = localStorage.getItem('email');
    if(emailStorage){
      localStorage.removeItem('email');
    }
  }
  backToLogin() {
    this.$router.push("/email");
  }
}
